import type { newApi, WasmApi } from "@kaleidoscope-solutions/engine-wasm"

interface EngineApi {
  WasmApi: typeof WasmApi
  newApi: typeof newApi
}

export async function apiLoader(): Promise<EngineApi> {
  const engine = await import("@kaleidoscope-solutions/engine-wasm")
  await engine.default()

  // eslint-disable-next-line no-console
  console.debug(
    "**wasm library initialised (dynamic), any prior object references will be invalid**"
  )
  return engine
}

export type { EngineApi }
